import type { Manifest } from './base/Field'
import HyModel from './base/Model'

export default class Item extends HyModel {

  override options() {
    return {
      remoteModel: 'CollectionItem'
    }
  }

  override manifest(): Manifest {
    return {
      slug: {},
      name: {},
      item_type: {},
      item_route: {},
      notes: {},
      collection_slug: {},
      item_attributes: {},
      collectable_type: {},
      collectable_id: {},
      collectable_model: {},
      error: {
        type: 'virtual',
        default: ''
      }
    }
  }

  override actions() {
    return {
      create: {
        method: 'POST',
        route: 'collections/{collection_slug}/items'
      }
    }
  }

  get valid() {
    return isEmpty(this.get('error'))
  }

  get route() {
    const json = this.get('item_route')
    return isEmpty(json) ? {} : JSON.parse(json)
  }

  setItemAttribute(name: string, value: any) {
    const itemAttributes = this.get('item_attributes')
    itemAttributes[name] = value
    this.set('item_attributes', itemAttributes)
  }

  static create(collectionItem: CollectionItem, collection: any) {
    // Create item and assign properties
    const newItem = new Item({}, collection)
    newItem.set({
      ...collectionItem,
      item_route: JSON.stringify(collectionItem.item_route)
    })
    // Return new item
    return newItem
  }
}
